module.exports = __webpack_public_path__ + "static/img/8.b325329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/8.png
// module id = pv22
// module chunks = 0